import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d16121b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "info-container" }
const _hoisted_3 = { class: "project-name" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "technologies" }

import Project from '@/types/Project.type';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCard',
  props: {
  project: { type: Object as PropType<Project>, required: true },
},
  setup(__props) {

const props = __props;

//* Functions.
const goToProject = () => {
  const website = props.project.link;
  window.open(website, "_blank") || window.location.replace(website);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "project-card",
    onClick: goToProject
  }, [
    _createElementVNode("img", {
      src: require('@/assets/images/projects' + __props.project.img),
      alt: __props.project.name,
      class: "project-img"
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.project.name), 1),
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, _toDisplayString(__props.project.technologies.toString().replaceAll(',', ', ')), 1)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["badge", __props.project.type])
    }, _toDisplayString(__props.project.type), 3)
  ]))
}
}

})